import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AndroidControlService } from 'src/app/androidControl/androidControl.service';
import { MappingsService } from 'src/app/nav-processing/mappings/mappings.service';
import {
  MappingsOutputType,
  MappingsOutput,
} from 'src/app/nav-processing/mappings/mappings.model';
import { EyeTrackerService } from 'src/app/nav-driver/tobii/eye-tracker.service';
import { NavigationCursorServiceSettings } from './navigation-cursor.model';

@Injectable({
  providedIn: 'root',
})
export class EyeNavigationService {
  gazeElm: any;
  dwellElm: any;
  gazedItem: Element;
  cursorElm = document.createElement('div');

  settings: NavigationCursorServiceSettings; // read only

  showGazePoint = false;
  clickEnabled = true;

  private initialized = false;

  //private dwellTimer: any;
  //private dwellDuration = 1500;
  //private dwellTimerProgress = 0;

  private lastItem: Element;
  private gazePositionSubscription: Subscription;
  private selectFeedbackSubscription: Subscription;

  private flagStarted = false;

  private gazeCoords: { x: number; y: number };

  constructor(
    //private profile: ProfileService
    // private peyeTrackerService: PeyeService,
    private eyeTrackerService: EyeTrackerService,
    private android: AndroidControlService,
    private mappings: MappingsService
  ) {}

  async start() {
    if (this.initialized) {
      return;
    }

    this.initialized = true;
    this.eyeTrackerService.isSleeping = false;
    this.gazeCoords = { x: 0, y: 0 };
    console.log('eye-navigation start');
    //this.eyeTrackerService.start();
    /* if (this.flagStarted === false) {
      console.log('flag started peye tracker');
      this.peyeTrackerService.connectPeye();
      this.peyeTrackerService.watchPeyeResponse();
      this.peyeTrackerService.watchPeyeResult();
      this.peyeTrackerService.setPeyeParams();
      this.peyeTrackerService.initPeye();
      //this.eyeTrackerService.startPeye();
      this.flagStarted = true;
    }*/

    this.createGazeElm();
    this.createDwellElm();
    this.createNavCursorElm();

    this.gazePositionSubscription = this.mappings.outputBS
      .pipe(
        filter(
          (data) =>
            data.type === MappingsOutputType.feedbackPositionH ||
            data.type === MappingsOutputType.feedbackPositionV ||
            data.type === MappingsOutputType.select
        )
      )
      .subscribe((data) => {
        this.onGazePositionUpdated(data);
      });

    this.selectFeedbackSubscription = this.mappings.outputBS
      .pipe(filter((data) => data.type === MappingsOutputType.feedbackSelect))
      .subscribe((data) => {
        this.refreshDwellProgressBar(data.value);
      });

    //this.dwellDuration = dwellDuration;

    this.placeCursor();

  }


  /**
   * Stops the eye tracker navigation
   */
  stop() {
    this.initialized = false;
    //this.peyeTrackerService.disconnectPeye();
    //this.flagStarted = false;
    console.log('eye-navigation stop');
    //this.eyeTrackerService.stop();
    this.gazePositionSubscription?.unsubscribe();
    //clearInterval(this.dwellTimer);
    this.dismissGazedItem();
    this.removeDwellElm();
    this.removeNavCursorElm(); // Removes the cursor elm
    this.removeGazeElm();
  }

  /**
   * Gets the navigable rows that are inside the current active ion page.
   */
  private getNavigableRowsFromActivePage() {
    console.log('getNavigableRowsFromActivePage')
    const ionPages = Array.from(document.querySelectorAll('.ion-page'));
      console.log('ionpages (row)', ionPages);
    let navRows: Array<Element> = [];

    // for(const ionPage of ionPages){
    //  const rows = ionPage.querySelectorAll('[data-grid-row]');
    //  console.log('rows: ', rows);
    //  navRows = Array.from(rows);
    // }
    if (ionPages.length > 0) {
      const lastIonPage = ionPages[ionPages.length - 1];
      console.log('lastIonPage rows: ', lastIonPage);
      const rows = lastIonPage.querySelectorAll('[data-grid-row]'); //problema
      console.log('rows: ', rows);
      navRows = Array.from(rows);
      console.log('navRows: ', navRows);
    } else {
      navRows = undefined;
    }
    //console.log('navRows: ', navRows)

    return navRows;
  }

  public placeCursor(){
    console.log('placeCursor')
    document.querySelectorAll('.app-nav-cursor-active').forEach((elm) => {
      elm.classList.remove('app-nav-cursor-active');
    });
    // Appends the cursor at the same node of the first row. This way, the cursor can be
    // place behind the navigable items.
    const allRows = this.getNavigableRowsFromActivePage();
    //console.log('allRows: ', allRows);
    if (allRows?.length > 0) {
      const rowElem = allRows.shift();
      //console.log('rowElem: ', rowElem);
      rowElem?.append(this.cursorElm);
      //rowElem?.append(this.dwellElm);
    }
  }

  /**
   * Creates the navigation cursor element
   */
  private createNavCursorElm() {
    // Check if the cursor element already exists
    if (!document.getElementById('nav-cursor')) {
      this.cursorElm.id = 'nav-cursor';
      document.body.appendChild(this.cursorElm);
    } else {
      this.cursorElm = document.getElementById('nav-cursor') as HTMLDivElement;
    }
    this.cursorElm.style.cssText =
      'position:fixed;width:0;height:0;opacity:1;z-index:-1;background:rgb(48, 107, 248, 0.8);transition: all 500ms; border-radius: 10px; box-shadow: rgb(48, 107, 248) 0px 0px 5px 10px;';
    // document.body.appendChild(this.cursorElm);
    //this.dwellElm.id = 'nav-feedback';
    //this.dwellElm.style.cssText = 'position:fixed; z-index:99; top: 0px; left: 0px; opacity: 1; background: #3880ff78; transition: width 500ms;';
  }

  /**
   * Removes the navigation cursor element
   */
  private removeNavCursorElm() {
    this.cursorElm?.remove();
    document.querySelectorAll('.app-nav-cursor-active').forEach((elm) => {
      elm.classList.remove('app-nav-cursor-active');
    });
  }

  /**
   * Searches for a navigable item within the touched element tree. In other words, look for an element
   * tree that has the custom property data-grid-col.
   *
   * @param touchedElement
   * @returns
   */
  searchForNavigableItem(touchedElement: Element) {
    let element = touchedElement;

    const elements = [];

    // The first five elements of the touched node tree
    for (let i = 0; i < 5; i++) {
      elements.push(element);
      element = element.parentElement;
    }

    return elements.find((ele) => ele && ele.dataset.hasOwnProperty('gridCol'));
  }

  /**
   * Handles when a gaze position is updated
   *
   * @param x gaze's x position
   * @param y gaze's y position
   */
  private onGazePositionUpdated(event: MappingsOutput) {
    if (event.type === MappingsOutputType.select) {
      this.onDwellTimerFinished();
      return;
    } else if (event.type === MappingsOutputType.feedbackPositionH) {
      this.gazeCoords = { x: event.value, y: this.gazeCoords.y };
    } else if (event.type === MappingsOutputType.feedbackPositionV) {
      this.gazeCoords = { x: this.gazeCoords.x, y: event.value };
    }

    // Calculates the Browser's header height
    //const browserHeaderHeight = window.outerHeight - window.innerHeight;

    // Calculates the x coord position relative to the document (xd = x coord position relative to document)
    const xd = this.gazeCoords.x * window.innerWidth;

    // Calculates the y coord position relative to the document (yd = y coord position relative to document)
    const yd = this.gazeCoords.y * window.innerHeight;

    // Gets the nav item at gaze point
    let gazedNavItem = document
      .elementsFromPoint(xd, yd)
      .find((elm) => (elm as any).dataset.hasOwnProperty('gridCol'));

    const gazedElements = document.elementsFromPoint(xd, yd);

    const sleepBtnElm = this.findSleepBtnElm(gazedElements);

    if (sleepBtnElm) {
      gazedNavItem = sleepBtnElm;
    }

    this.lastItem = gazedNavItem;

    if (this.showGazePoint) {
      // Debug: Red dot to show the center of the gaze
      //console.log('xd: ', xd, 'yd: ', yd);
      this.gazeElm.style.left = xd.toString() + 'px';
      this.gazeElm.style.top = yd.toString() + 'px';
    }

    // OPTION A: Considers leaving the element a change and cancels the dwell animation
    /*if (this.gazedItem?.innerHTML !== gazedNavItem?.innerHTML) {
      this.onGazedItemChanged(gazedNavItem);
    }*/

    // OPTION B: Only cancels when entering another element
    if (this.gazedItem && gazedNavItem) {
      if (this.gazedItem.innerHTML !== gazedNavItem.innerHTML) {
        this.onGazedItemChanged(gazedNavItem);
      }
    } else if (!this.gazedItem) {
      this.gazedItem = gazedNavItem;
   }
  }

  /**
   * Dismisses the touched item.
   */
  private dismissGazedItem() {
    // Cancel dwell timer
    //clearInterval(this.dwellTimer);

    if (this.gazedItem) {
      //   this.gazedItem.classList.remove('app-cursor-highlight');
      this.gazedItem.classList.remove('app-cursor-highlight-green');
    }

    if (this.cursorElm) {
      this.cursorElm.style.width = '0px';
      this.cursorElm.style.height = '0px';
      this.cursorElm.style.opacity = '0';
    }

    if (this.dwellElm) {
      this.dwellElm.style.width = '0px';
      this.dwellElm.style.height = '0px';
    }

    this.gazedItem = null;
  }

  /**
   * Handles when the touch item changes.
   *
   * @param event touch event
   */
  private onGazedItemChanged(elm: Element) {
    this.mappings.navCursorDataHandler({
      navData: { event: 'cursorPositionChanged' },
      captureTime: Date.now(),
    });

    // Dismiss the previous touched item.
    this.dismissGazedItem();

    // Updates for the new touched item.
    this.gazedItem = elm;

    if (
      this.gazedItem &&
      (!this.eyeTrackerService.isSleeping ||
        this.gazedItem.id === 'eye-tracker-sleep-btn')
    ) {
      //this.gazedItem.classList.add('app-cursor-highlight');

      const elmRect = this.gazedItem.getBoundingClientRect();

      this.dwellElm.style.top = elmRect.top.toString() + 'px';
      this.dwellElm.style.left = elmRect.left.toString() + 'px';
      // this.dwellElm.style.width = elmRect.width.toString() + 'px';
      this.dwellElm.style.height = elmRect.height.toString() + 'px';

      //this.refreshDwellProgressBar();

      //Alguns problemas: some quando troca de página
      if (this.lastItem && this.gazedItem) {
        this.cursorElm.style.opacity = '100';
        // Gets the rectangle that bounds the items.
        const firstItemRec = this.gazedItem.getBoundingClientRect();
        const lastItemRec = this.lastItem.getBoundingClientRect();
        console.log(
          'firstItemRec: ',
          firstItemRec,
          'lastItemRec: ',
          lastItemRec
        ); //são a msm coisa mas de alguma forma funciona

        // Calculates the cursor's propreties like width and height so it envolves all items in the group.
        if (firstItemRec.top === lastItemRec.top) {
          console.log('items beside');
          // When the items are beside each other...
          const cursorWidth =
            lastItemRec.left - firstItemRec.left + lastItemRec.width;
          this.cursorElm.style.top = firstItemRec.top.toString() + 'px';
          this.cursorElm.style.left = firstItemRec.left.toString() + 'px';
          this.cursorElm.style.width = cursorWidth.toString() + 'px';
          this.cursorElm.style.height = firstItemRec.height.toString() + 'px';
        } else {
          console.log('items beneath');
          // When the items are beneath each other...
          const cursorHeight =
            lastItemRec.top - firstItemRec.top + lastItemRec.height;
          this.cursorElm.style.top = firstItemRec.top.toString() + 'px';
          this.cursorElm.style.left = firstItemRec.left.toString() + 'px';
          this.cursorElm.style.width = firstItemRec.width.toString() + 'px';
          this.cursorElm.style.height = cursorHeight.toString() + 'px';
        }

        if ((this.gazedItem as any).dataset.hasOwnProperty('gridRow')) {
          this.cursorElm.style.width = '100%';
          this.cursorElm.style.left = '0';
          this.cursorElm.style.borderRadius = '0';
          this.cursorElm.style.boxShadow =
            'rgb(255, 0, 0)';
        } else if ((this.gazedItem as any).dataset.hasOwnProperty('gridCol')) {
          // Sets the cursor's border radius to match the item's border radius.
          this.cursorElm.style.borderRadius = window.getComputedStyle(
            this.gazedItem
          ).borderRadius;

          this.cursorElm.style.boxShadow =
            'rgb(48, 107, 248, 0.8) 0px 0px 5px 10px;';
        }
      } else {
        console.log('gazedItem or lastItem is null');
      }
    }

    this.lastItem = this.gazedItem;

    // clearTimeout(this.dwellTimer);
    // this.dwellTimer = setTimeout(() => {
    //   this.onDwellTimerFinished();
    // }, 1000);
  }

  /**
   * Handles when the  dwell timer finishes
   */
  private onDwellTimerFinished() {
    // this.dwellElm.style.background = '#95ff3878'; // Cor verde de fundo da seleção

    if (this.gazedItem && this.gazedItem.id === 'eye-tracker-sleep-btn') {
      if (this.eyeTrackerService.isSleeping) {
        this.eyeTrackerService.awake();
      } else {
        this.eyeTrackerService.sleep();
      }
      this.dismissGazedItem();
    } else if (this.gazedItem && !this.eyeTrackerService.isSleeping) {
      this.gazedItem.classList.add('app-cursor-highlight-green');
      if (this.clickEnabled) {
        (this.gazedItem as any).click();
      }
    }
  }

  /**
   * Creates the gaze element that shows the point the eyes are looking at.
   */
  private createGazeElm() {
    if (this.showGazePoint) {
      this.gazeElm = document.createElement('div');
      this.gazeElm.id = 'eye-tracker-gaze';
      // transform so that center of the gaze is the point
      document.body.appendChild(this.gazeElm);

      // Places the progress bar just bellow de toolbar.
      // eslint-disable-next-line max-len
      this.gazeElm.style.cssText =
        'position:absolute; top: 0px; left: 0px; opacity: 1; width: 25px;\
         height: 25px; background: red; border-radius: 50%; transform: translate(-50%, -50%); pointer-events: none;';
    }
  }

  /**
   * Creates the dwell element that shows the progress until the item be selected.
   */
   createDwellElm() {
    this.dwellElm = document.createElement('div');
    document.body.appendChild(this.dwellElm);

    // // Places the progress bar just bellow de toolbar.
    this.dwellElm.style.cssText =
      'position:absolute; top: 0px; left: 0px; opacity: 1; pointer-events: none;';
  }

  /**
   * Removes Gaze Elm.
   */
  private removeGazeElm() {
    this.gazeElm?.remove();
  }

  /**
   * Removes Dwell Elm
   */
   removeDwellElm() {
    this.dwellElm?.remove();
  }

  /**
   * Refreshes the dwell's progress bar.
   */

  // private refreshDwellProgressBar(progress: number) {

  //   if (this.gazedItem) {
  //       // this.dwellElm.style.background = 'radial-gradient(circle, transparent 0%, black 50%)';
  //       this.dwellElm.style.background = ' #95ff38';
  //       this.dwellElm.style.width = (this.gazedItem.clientWidth * progress).toString() + 'px';
  //       this.dwellElm.style.height = (this.gazedItem.clientHeight * progress).toString() + 'px';
  //       this.dwellElm.style.borderRadius = '50%';
  //       this.dwellElm.style.transition = 'transform 0.1s ease-in-out, opacity 0.1s ease-in-out';
  //       // this.dwellElm.style.transform = `scale(${progress})`;
  //       this.dwellElm.style.opacity = (1 - progress).toString();
  //       this.dwellElm.style.backgroundPosition = 'center';
  //       this.dwellElm.style.backgroundSize = '100% 100%';
  //   }
  // }

  

  // TESTE STACKOVERFLOW
  private refreshDwellProgressBar(progress: number) {
    if (this.gazedItem) {
        // Garante que dwellElm está configurado corretamente
        this.dwellElm.style.position = 'relative';
        this.dwellElm.style.width = `${this.gazedItem.clientWidth}px`;
        this.dwellElm.style.height = `${this.gazedItem.clientHeight}px`;
        // this.dwellElm.style.borderRadius = '50%';
        this.dwellElm.style.overflow = 'hidden'; // Para evitar que a animação ultrapasse os limites

        // Criando a camada de efeito se ainda não existir
        let effectLayer = this.dwellElm.querySelector('.effect-layer') as HTMLDivElement;
        if (!effectLayer) {
            effectLayer = document.createElement('div');
            effectLayer.classList.add('effect-layer');
            this.dwellElm.appendChild(effectLayer);
        }

        // Estilizando a camada de efeito
        effectLayer.style.position = 'absolute';
        effectLayer.style.top = '0';
        effectLayer.style.left = '0';
        effectLayer.style.right = '0';
        effectLayer.style.bottom = '0';
        effectLayer.style.borderRadius = '5%';
        effectLayer.style.background = 'radial-gradient(circle, transparent 1%,rgba(56, 128, 255, 0.47) 1.5%)';
        effectLayer.style.backgroundPosition = 'center';
        effectLayer.style.backgroundSize = `${100 + (1 - progress) * 10000}% ${100 + (1 - progress) * 10000}% `;
        effectLayer.style.color = 'transparent';
        effectLayer.style.transition = 'background-size opacity 0.1s ease-in';
        effectLayer.style.opacity = progress.toString();
    }
}





  private findSleepBtnElm(gazeElemnts: Element[]) {
    return gazeElemnts.find(
      (elm) => (elm as any).id === 'eye-tracker-sleep-btn'
    );
  }
}
